"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsPlugin = void 0;
var index_1 = require("../../src/index");
var fas = __importStar(require("@fortawesome/free-solid-svg-icons/faChartPie"));
var TableXResults_1 = require("../TableXResults");
var DisplayStats_1 = require("./DisplayStats");
var ParseDataStats_1 = require("./ParseDataStats");
var I18n_1 = require("../sparnatural-yasr-plugin-grid/I18n");
var StatsPlugin = /** @class */ (function () {
    function StatsPlugin(yasr) {
        this.displayStats = new DisplayStats_1.DisplayStats();
        this.parseDataStats = new ParseDataStats_1.ParseDataStats();
        this.priority = 3;
        this.label = "Stats";
        this.yasr = yasr;
        this.config = StatsPlugin.defaults;
    }
    StatsPlugin.prototype.loadTranslations = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, I18n_1.I18n.init(lang)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatsPlugin.prototype.getTranslation = function (key) {
        return I18n_1.I18n.labels ? I18n_1.I18n.labels[key] || key : key;
    };
    StatsPlugin.prototype.download = function (filename) {
        var _this = this;
        return {
            getData: function () { var _a; return ((_a = _this.yasr.results) === null || _a === void 0 ? void 0 : _a.asCsv()) || ""; },
            contentType: "text/csv",
            title: "Download result",
            filename: "".concat(filename || "queryResults", ".csv"),
        };
    };
    // Add icon
    StatsPlugin.prototype.getIcon = function () {
        return (0, index_1.drawSvgStringAsElement)((0, index_1.drawFontAwesomeIconAsSvg)(fas));
    };
    StatsPlugin.prototype.draw = function (persistentConfig) {
        this.loadTranslations(this.config.lang);
        // Récupérer les résultats
        var results = new TableXResults_1.TableXResults(this.yasr.results);
        // Récupérer les bindings
        var bindings = results.getBindings();
        console.log("Bindings :", bindings);
        this.displayStats.displayStats(bindings, this.yasr.resultsEl, I18n_1.I18n.labels);
    };
    //limiter ce plugin sur deux colonne si le nombre de colonne est superieur à 2 ne s'acctive pas
    //-----------------------------------!!!!!!!-----------------------------------
    StatsPlugin.prototype.canHandleResults = function () {
        var _a;
        // Vérification initiale
        if (!this.query || !this.queryConfiguration) {
            return false;
        }
        // Obtention des bindings
        var bindings = (_a = this.yasr.results) === null || _a === void 0 ? void 0 : _a.getBindings();
        if (!bindings)
            return false;
        // Validation des bindings
        for (var _i = 0, bindings_1 = bindings; _i < bindings_1.length; _i++) {
            var bindingSet = bindings_1[_i];
            for (var _b = 0, _c = Object.values(bindingSet); _b < _c.length; _b++) {
                var value = _c[_b];
                if (typeof value === "object" && value !== null) {
                    // Validation des variables de la requête
                    return this.query.variables.some(function (variable) {
                        return variable.expression && typeof variable.expression === "object";
                    });
                }
            }
        }
        return false;
    };
    // Notifier le plugin des changements dans les valeurs de query et queryConfiguration
    StatsPlugin.prototype.notifyQuery = function (sparnaturalQuery) {
        this.query = sparnaturalQuery;
        console.log("Query :", this.query);
    };
    StatsPlugin.prototype.notifyConfiguration = function (specProvider) {
        this.queryConfiguration = specProvider;
    };
    StatsPlugin.defaults = {
        lang: "en",
    };
    return StatsPlugin;
}());
exports.StatsPlugin = StatsPlugin;
